import { createModule } from "@Actions/utils";
import { SERVICE_ENDPOINT } from "@Apis/constants";

const BulkUploadPO = createModule({
  base: "UPLOAD_BULK_PO",
  apiDetails: SERVICE_ENDPOINT.UPLOAD_BULK_PO,
  errors: { defaultError: false, customError: "" },
});

const GetPurchaseOrders = createModule({
  base: 'GET_PURCHASE_ORDERS_V2',
  apiDetails: SERVICE_ENDPOINT.GET_PURCHASE_ORDERS,
  errors: { defaultError: false, customError: '' },
});
const SplitStatusPo = createModule({
  base: 'SPLIT_STATUS_PO',
  apiDetails: SERVICE_ENDPOINT.SPLIT_STATUS_PO,
  enableNotification: true,
});

export { BulkUploadPO, GetPurchaseOrders, SplitStatusPo };
